/* SOLSTEAD theme.js - back-button scroll memory, gallery (thumbs, arrows, swipe, dots, preloading), shop menu, scroll-spy, scent flip, size picker (price / size / gallery / DESCRIPTION swap), 13.75 oz free-mini add, cart stepper. */
(function () {
  /* ---- back button lands exactly where the customer left. ---- */
  try {
    var scrollKey = 'sol-scroll:' + location.pathname + location.search;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    function rememberScroll() { try { sessionStorage.setItem(scrollKey, String(window.pageYOffset || document.documentElement.scrollTop || 0)); } catch (e) {} }
    window.addEventListener('pagehide', rememberScroll);
    window.addEventListener('beforeunload', rememberScroll);
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (a && !/^#/.test(a.getAttribute('href') || '')) rememberScroll();
    }, true);
    var navType = '';
    try {
      var ent = performance.getEntriesByType && performance.getEntriesByType('navigation');
      if (ent && ent.length) navType = ent[0].type;
      else if (performance.navigation && performance.navigation.type === 2) navType = 'back_forward';
    } catch (e) {}
    function restoreScroll() {
      var saved = null;
      try { saved = sessionStorage.getItem(scrollKey); } catch (e) {}
      if (saved === null || location.hash) return;
      var target = parseInt(saved, 10);
      if (isNaN(target)) return;
      var tries = 0;
      (function go() {
        window.scrollTo(0, target);
        tries++;
        if (tries < 40 && Math.abs((window.pageYOffset || 0) - target) > 2) requestAnimationFrame(go);
      })();
    }
    if (navType === 'back_forward') restoreScroll();
    window.addEventListener('pageshow', function (e) { if (e.persisted) restoreScroll(); });
  } catch (e) {}

  /* ---- product gallery thumbs (rebindable) + quiet preloading ---- */
  var mainImg = document.querySelector('[data-gallery-main] img:not(.gal-ignore)');
  var warmed = {};
  function warmThumbs() {
    try {
      var thumbs = document.querySelectorAll('[data-gallery-thumb]');
      Array.prototype.forEach.call(thumbs, function (btn) {
        var src = btn.getAttribute('data-src');
        if (!src || warmed[src]) return;
        warmed[src] = true;
        var im = new Image();
        im.decoding = 'async';
        im.src = src;
      });
    } catch (e) {}
  }
  function scheduleWarm() {
    if ('requestIdleCallback' in window) requestIdleCallback(warmThumbs, { timeout: 2500 });
    else setTimeout(warmThumbs, 1200);
  }
  function bindThumbs() {
    try {
      var thumbs = document.querySelectorAll('[data-gallery-thumb]');
      if (!mainImg || !thumbs.length) return;
      Array.prototype.forEach.call(thumbs, function (btn) {
        btn.addEventListener('click', function () {
          mainImg.src = btn.getAttribute('data-src');
          mainImg.alt = btn.getAttribute('data-alt') || '';
          Array.prototype.forEach.call(thumbs, function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
        });
      });
      scheduleWarm();
    } catch (e) {}
  }
  bindThumbs();

  /* ---- gallery arrows (PC) + swipe & dots (phone) ---- */
  try {
    var galMain = document.querySelector('[data-gallery-main]');
    if (galMain) {
      var prevBtn = document.querySelector('[data-gal-prev]');
      var nextBtn = document.querySelector('[data-gal-next]');
      var dotsWrap = document.querySelector('[data-gal-dots]');
      function galThumbs() { return document.querySelectorAll('[data-gallery-thumb]'); }
      function galStep(d) {
        var t = galThumbs();
        if (t.length < 2) return;
        var i = 0;
        for (var k = 0; k < t.length; k++) { if (t[k].classList.contains('active')) { i = k; break; } }
        t[(i + d + t.length) % t.length].click();
      }
      function renderDots() {
        if (!dotsWrap) return;
        var t = galThumbs();
        dotsWrap.innerHTML = '';
        if (t.length < 2) return;
        Array.prototype.forEach.call(t, function (th, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'gal-dot' + (th.classList.contains('active') ? ' active' : '');
          d.setAttribute('aria-label', 'Photo ' + (i + 1));
          d.addEventListener('click', function () { th.click(); });
          dotsWrap.appendChild(d);
        });
      }
      function galSync() {
        var show = galThumbs().length > 1;
        if (prevBtn) prevBtn.hidden = !show;
        if (nextBtn) nextBtn.hidden = !show;
        renderDots();
      }
      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); galStep(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); galStep(1); });
      document.addEventListener('gallery:rebuilt', galSync);
      document.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('[data-gallery-thumb]')) renderDots();
      });
      galSync();
      var sx = 0, sy = 0;
      galMain.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
      galMain.addEventListener('touchend', function (e) {
        var t = e.changedTouches[0];
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.5) galStep(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
  } catch (e) {}

  /* ---- shop menu: close on outside click / escape ---- */
  try {
    var shopMenu = document.querySelector('[data-shop-menu]');
    if (shopMenu) {
      document.addEventListener('click', function (e) {
        if (shopMenu.open && !shopMenu.contains(e.target)) shopMenu.removeAttribute('open');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && shopMenu.open) shopMenu.removeAttribute('open');
      });
    }
  } catch (e) {}

  /* ---- free-mini options: mark the chosen one with a class ---- */
  try {
    var miniLabels = document.querySelectorAll('[data-mini-pick] .mp-opt');
    function paintMini() {
      Array.prototype.forEach.call(miniLabels, function (l) {
        var r = l.querySelector('input[name="free-mini"]');
        if (r && r.checked) l.classList.add('is-on'); else l.classList.remove('is-on');
      });
    }
    if (miniLabels.length) {
      paintMini();
      Array.prototype.forEach.call(miniLabels, function (l) {
        var r = l.querySelector('input[name="free-mini"]');
        if (r) r.addEventListener('change', paintMini);
      });
    }
  } catch (e) {}

  /* ---- size picker: one page per scent, three sizes, swap in place (price, size line, gallery, DESCRIPTION). ---- */
  try {
    var opts = document.querySelectorAll('[data-size-opt]');
    var formEl = document.querySelector('form[data-buy-form]');
    if (opts.length > 1 && formEl) {
      var idIn = formEl.querySelector('input[name="id"]');
      var addBtn = formEl.querySelector('button[name="add"]');
      var priceEl = document.querySelector('.buy-price');
      var subEl = document.querySelector('.buy-sub');
      var fitEl = document.querySelector('.fit-line');
      var pickEl = document.querySelector('[data-mini-pick]');
      var ritEl = document.querySelector('[data-ritual-invite]');
      var descEl = document.querySelector('[data-pd-desc]');
      var thumbsWrap = document.querySelector('.gallery-thumbs');

      function setGallery(vid) {
        var s = document.querySelector('script[data-size-media="' + vid + '"]');
        if (!s) return;
        var media;
        try { media = JSON.parse(s.textContent); } catch (e) { return; }
        if (!media || !media.length) return;
        if (mainImg) { mainImg.src = media[0].src; mainImg.alt = media[0].alt || ''; }
        if (thumbsWrap) {
          thumbsWrap.innerHTML = '';
          media.forEach(function (m, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('data-gallery-thumb', '');
            b.setAttribute('data-src', m.src);
            b.setAttribute('data-alt', m.alt || '');
            b.setAttribute('aria-label', 'View image ' + (i + 1));
            if (i === 0) b.className = 'active';
            var im = document.createElement('img');
            im.src = m.thumb; im.alt = ''; im.loading = 'lazy'; im.width = 72; im.height = 72;
            b.appendChild(im);
            thumbsWrap.appendChild(b);
          });
          thumbsWrap.hidden = media.length < 2;
          bindThumbs();
          try { document.dispatchEvent(new CustomEvent('gallery:rebuilt')); } catch (e) {}
        }
      }

      function setDescription(vid) {
        if (!descEl) return;
        var tpl = document.querySelector('template[data-size-desc="' + vid + '"]');
        if (!tpl) return;
        descEl.innerHTML = tpl.innerHTML; /* server-rendered Shopify description for that size, never user input */
      }

      Array.prototype.forEach.call(opts, function (o) {
        o.addEventListener('click', function () {
          if (o.classList.contains('active')) return;
          Array.prototype.forEach.call(opts, function (x) { x.classList.remove('active'); x.setAttribute('aria-pressed', 'false'); });
          o.classList.add('active'); o.setAttribute('aria-pressed', 'true');
          var kind = o.getAttribute('data-kind');
          var avail = o.getAttribute('data-avail') === 'true';
          var vid = o.getAttribute('data-vid');
          if (idIn) idIn.value = vid;
          if (priceEl) priceEl.textContent = o.getAttribute('data-price');
          if (subEl) subEl.textContent = o.getAttribute('data-size') + ' \u00b7 100% natural soy wax \u00b7 hand\u2011poured in the USA';
          if (fitEl) fitEl.textContent = o.getAttribute('data-fit');
          if (pickEl) pickEl.hidden = kind !== 'reserve';
          if (ritEl) ritEl.hidden = kind !== 'core';
          if (addBtn) { addBtn.disabled = !avail; addBtn.textContent = avail ? 'Add to evening \u2192' : 'Sold out'; }
          setGallery(vid);
          setDescription(vid);
          var url = o.getAttribute('data-url');
          if (url && window.history && history.replaceState) history.replaceState(null, '', url);
        });
      });
    }
  } catch (e) {}

  /* ---- 13.75 oz: add the chosen free mini as a second line item ---- */
  try {
    var form = document.querySelector('form[data-buy-form]');
    var pick = document.querySelector('[data-mini-pick]');
    if (form && pick) {
      var errEl = document.querySelector('[data-buy-err]');
      form.addEventListener('submit', function (e) {
        if (pick.hidden) return;
        var picked = pick.querySelector('input[name="free-mini"]:checked');
        var idField = form.querySelector('input[name="id"]');
        if (!picked || !idField) return;
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
        if (errEl) errEl.hidden = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [
            { id: Number(idField.value), quantity: 1 },
            { id: Number(picked.value), quantity: 1 }
          ] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/cart';
        }).catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
          form.submit();
        });
      });
    }
  } catch (e) {}

  /* ---- cart: minus / plus / remove / typed quantity all save themselves, then the page refreshes ---- */
  try {
    var cartLines = document.querySelector('[data-cart-lines]');
    if (cartLines) {
      var cartErr = document.querySelector('[data-cart-err]');
      var busy = false;
      function changeLine(line, qty) {
        if (busy) return;
        busy = true;
        cartLines.classList.add('is-busy');
        if (cartErr) cartErr.hidden = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        }).then(function (r) {
          if (!r.ok) throw new Error('change failed');
          window.location.reload();
        }).catch(function () {
          busy = false;
          cartLines.classList.remove('is-busy');
          if (cartErr) cartErr.hidden = false;
        });
      }
      Array.prototype.forEach.call(cartLines.querySelectorAll('[data-line]'), function (row) {
        var line = Number(row.getAttribute('data-line'));
        var input = row.querySelector('[data-qty-input]');
        var minus = row.querySelector('[data-qty-minus]');
        var plus = row.querySelector('[data-qty-plus]');
        var remove = row.querySelector('[data-qty-remove]');
        function current() { var n = parseInt(input && input.value, 10); return isNaN(n) || n < 0 ? 0 : n; }
        if (minus) minus.addEventListener('click', function () { changeLine(line, Math.max(0, current() - 1)); });
        if (plus) plus.addEventListener('click', function () { changeLine(line, current() + 1); });
        if (remove) remove.addEventListener('click', function (e) { e.preventDefault(); changeLine(line, 0); });
        if (input) {
          input.addEventListener('change', function () { changeLine(line, current()); });
          input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); changeLine(line, current()); } });
        }
      });
    }
  } catch (e) {}

  /* ---- FLIP PLATES (scent cards, gift-set cards, gift-box composite). ONE rule on every screen:
          - Desktop (can hover): hover shows the other face; a click on the front face flips it; the back face is the link.
          - Phones / tablets (no hover): a SHORT TAP on the picture OPENS THE PRODUCT the moment the finger lifts - we
            navigate straight from touchend, so iPhone's 'first tap = hover, second tap = click' rule never gets a chance
            (5 Sep: gift boxes needed two taps). A press held longer than 350 ms peeks at the other face and does NOT open.
            The hover styles themselves are disabled on touch screens in polish.css for the same reason. ---- */
  try {
    var canHover = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    Array.prototype.forEach.call(document.querySelectorAll('[data-flip]'), function (plate) {
      var unflip = null;
      var moved = false;
      var t0 = 0;
      var navigated = false;
      var btn = plate.querySelector('[data-flip-btn]');
      var back = plate.querySelector('a.pf-back');
      function show() { moved = false; t0 = Date.now(); if (unflip) { clearTimeout(unflip); unflip = null; } plate.classList.add('flipped'); }
      function hide() { if (unflip) clearTimeout(unflip); unflip = setTimeout(function () { plate.classList.remove('flipped'); unflip = null; }, 200); }
      plate.addEventListener('touchstart', show, { passive: true });
      plate.addEventListener('touchmove', function () { moved = true; }, { passive: true });
      plate.addEventListener('touchend', function () {
        var held = Date.now() - t0;
        hide();
        if (!canHover && back && back.href && !moved && held < 350 && !navigated) {
          navigated = true;
          window.location.href = back.href;
        }
      }, { passive: true });
      plate.addEventListener('touchcancel', hide, { passive: true });
      if (btn) btn.addEventListener('click', function (e) {
        if (!canHover) { e.preventDefault(); if (back && back.href && !navigated) { navigated = true; window.location.href = back.href; } return; }
        plate.classList.add('flipped');
      });
    });
    window.addEventListener('pageshow', function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-flip].flipped'), function (p) { p.classList.remove('flipped'); });
    });
  } catch (e) {}

  /* ---- library scroll-spy ---- */
  try {
    var panels = document.querySelectorAll('[data-panel]');
    var links = document.querySelectorAll('.idx-link');
    if (panels.length && links.length && 'IntersectionObserver' in window) {
      var byHandle = {};
      Array.prototype.forEach.call(links, function (l) { byHandle[l.getAttribute('data-idx')] = l; });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            Array.prototype.forEach.call(links, function (l) { l.classList.remove('active'); });
            var link = byHandle[en.target.getAttribute('data-panel')];
            if (link) link.classList.add('active');
          }
        });
      }, { rootMargin: '-35% 0px -55% 0px' });
      Array.prototype.forEach.call(panels, function (p) { obs.observe(p); });
    }
  } catch (e) {}
})();
